<template>
  <div>
    <h1 class="display-4">Importation EventDB v1 vers EventDB v2</h1>
    <hr />
    <div class="my-3" v-show="!importing">
      <b-row>
        <b-col cols="2">
          <b-select class="mb-4" :options="ecoles" v-model="ecole"></b-select>
        </b-col>
        <b-col cols="10">
          <b-btn variant="primary" :disabled="errorType || errorEstablishment" @click.prevent="importData">Vérifier l'importation</b-btn>
          <b-btn variant="primary" v-show="events_to_import.length > 0" :disabled="errorType || errorEstablishment" @click.prevent="importTheData">Commencer l'importation des {{ events_to_import.length }} événements</b-btn>
        </b-col>
      </b-row>
      <div class="mt-3 alert alert-danger" v-show="errorType">
        Attention, les types suivants n'existent pas sur la nouvelle version d'EventDB. Merci de les créer avant de faire l'import.

        <ul>
          <li v-for="item in unknown_type" :key="item">{{ item }}</li>
        </ul>

        <b-btn variant="primary" @click.prevent="importTheData">J'ignore ce message d'erreur et j'importe les événements qui correspondent bien ({{ max }} / {{total_events }} seront importés)</b-btn>
      </div>
      <div class="mt-3 alert alert-danger" v-show="errorLabel">
        Attention, les labels suivants n'existent pas sur la nouvelle version d'EventDB. Merci de les créer avant de faire l'import.

        <ul>
          <li v-for="item in unknown_label" :key="item">{{ item }}</li>
        </ul>

        <b-btn variant="primary" @click.prevent="importTheData">J'ignore ce message d'erreur et j'importe les événements qui correspondent bien ({{ max }} / {{total_events }} seront importés)</b-btn>
      </div>
      <div class="mt-3 alert alert-danger" v-show="errorEstablishment">
        Attention, les établissements suivants n'existent pas sur la nouvelle version d'EventDB. Merci de les créer avant de faire l'import.

        <ul>
          <li v-for="item in unknown_establishments" :key="item">{{ item }}</li>
        </ul>

        <b-btn variant="primary" @click.prevent="importTheData">J'ignore ce message d'erreur et j'importe les événements qui correspondent bien ({{ max }} / {{total_events }} seront importés)</b-btn>
      </div>
    </div>
    <p class="text-center" v-show="importing"><em> {{ messageImport }}</em></p>
    <b-progress :value="counter" :variant="variant" :max="max" :animated="animate" v-show="counter > 0"></b-progress>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

Vue.use(VueResource)

export default {
  data () {
    return {
      counter: 0,
      ecole: 0,
      ecoles: [
        { text: '--- Sélectionnez une école ---', value: 0 },
        { text: 'e-artsup', value: 1 },
        { text: 'EPITA', value: 2 },
        { text: 'ESME Sudria', value: 4 },
        { text: 'ETNA', value: 5 },
        { text: 'Epitech', value: 3 },
        { text: 'IPSA', value: 7 },
        { text: 'ISEG', value: 21 },
        { text: 'ISG', value: 10 },
        { text: 'ISG Business & Management', value: 28 },
        { text: 'ISG International Business School', value: 29 },
        { text: 'ISG MSc & MBA', value: 26 },
        { text: 'ISTH', value: 11 },
        { text: 'Ionis-STM', value: 13 },
        { text: 'Moda Domani Institute', value: 25 },
        { text: 'SUP\'Internet', value: 17 },
        { text: 'Sup\'Biotech', value: 14 }
      ],
      errorEstablishment: false,
      errorLabel: false,
      errorType: false,
      establishments: [],
      events: [],
      events_to_import: [],
      importing: false,
      labels: [],
      messageImport: 'Importation des événements en cours...',
      // max: 502,
      schools: [],
      total_events: 0,
      types: [],
      unknown_establishments: [],
      unknown_label: [],
      unknown_type: []
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'role', 'theme', 'userId']),
    animate () {
      return this.counter !== this.max
    },
    max () {
      return this.events_to_import.length
    },
    variant () {
      return this.counter !== this.max ? 'primary' : 'success'
    }
  },
  methods: {
    format_date (value) {
      let parse = value.split(' ')
      let parse2 = parse[0].split('/')
      let date = new Date(parse2[2] + '-' + parse2[1] + '-' + parse2[0])
      return date
      // if (value) {
      //   return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      // }
      // return value
    },
    importTheData () {
      this.importing = true
      for (let i = 0; i < this.events_to_import.length; i++) {
        this.$http.post(this.domain + '/api/events?access_token=' + this.access_token, this.events_to_import[i], { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            if (response.status === 200 && response.ok) {
              this.counter++
              if (this.counter === this.max) {
                this.messageImport = 'Importation terminée !'
              }
            }
          })
        }, (response) => {

        })
      }
    },
    importData () {
      this.$http.get('https://ionis-group.pro/json.aspx?ecole=' + this.ecole).then((response) => {
        response.json().then((data) => {
          let events = data.events.event
          console.log(events)
          this.total_events = events.length
          for (let i = 0; i < events.length; i++) {
            let event = {
              title: events[i].titre,
              description: events[i].resume,
              start_date: new Date(this.format_date(events[i].date_debut)).toISOString(),
              // end_date: new Date(this.format_date(events[i].date_fin)).toISOString(),
              start_time: events[i].horaire_debut.toLowerCase(),
              end_time: events[i].horaire_fin.toLowerCase(),
              active: events[i].actif,
              registration_page_url: events[i].page_inscription_url,
              specific_page_url: events[i].page_specifique_url,
              salesforce_campaign: '',
              date_created: new Date().toISOString(),
              // typeId: this.typeId,
              // establishmentId: this.establishmentId,
              ionisId: this.userId,
              facebook: '',
              eventbrite: '',
              linkId: '',
              link_name: '',
              registration_required: false,
              contact: ''
              // ionisId: '5d931c61b81fd9cffeb7d4ca'
            }
            if (events[i].date_fin !== '01/01/2000 00:00:00') {
              event.end_date = new Date(this.format_date(events[i].date_fin)).toISOString()
            }
            // Recherche du type
            for (let t = 0; t < this.types.length; t++) {
              if (this.types[t].name.toLowerCase() === events[i].nom_type_evenement.toLowerCase()) {
                event.typeId = this.types[t].id
              }
              if ((events[i].nom_ecole === 'ISG B&M' && events[i].nom_type_evenement === 'Journée d’immersion' && this.types[t].name === 'Journées Immersives') || (events[i].nom_ecole === 'ISG B&M' && events[i].nom_type_evenement === 'Les Rendez-vous de l’orientation' && this.types[t].name === 'Journée Portes Ouvertes')) {
                event.typeId = this.types[t].id
              }
              if ((events[i].nom_ecole === 'EPITA' && events[i].nom_type_evenement === 'Journée d’immersion')) {
                event.typeId = this.types[t].id
              }
              if ((events[i].nom_ecole === 'EPITA' && events[i].nom_type_evenement === 'Evénements' && this.types[t].name === 'Evénement')) {
                event.typeId = this.types[t].id
              }
            }

            if (event.typeId === undefined) {
              if (!this.unknown_type.includes(events[i].nom_type_evenement)) {
                this.unknown_type.push(events[i].nom_type_evenement)
              }
            }

            // Recherche de l'école (juste pour le label en fait)

            let schoolId = ''

            for (let s = 0; s < this.schools.length; s++) {
              if (this.schools[s].name === events[i].nom_ecole) {
                schoolId = this.schools[s].id
              } else {
                if (this.schools[s].name === 'Moda Domani Institute' && events[i].nom_ecole === 'Moda Domani') {
                  schoolId = this.schools[s].id
                }
                if (this.schools[s].name === 'Ionis-STM' && events[i].nom_ecole === 'IONIS-STM') {
                  schoolId = this.schools[s].id
                }
                if (this.schools[s].name === 'ISG MSc & MBA' && events[i].nom_ecole === 'ISG MSc') {
                  schoolId = this.schools[s].id
                }
                if (this.schools[s].name === 'ISEG' && events[i].nom_ecole === 'ISEG MCS') {
                  schoolId = this.schools[s].id
                }
                if (this.schools[s].name === 'Sup\'Biotech' && events[i].nom_ecole === 'SupBiotech') {
                  schoolId = this.schools[s].id
                }
                if (this.schools[s].name === 'ISG Business & Management' && events[i].nom_ecole === 'ISG B&M') {
                  schoolId = this.schools[s].id
                }
                if (this.schools[s].name === 'ISG Bachelor Management International' && events[i].nom_ecole === 'ISG International') {
                  schoolId = this.schools[s].id
                }
              }
            }

            // Recherche du label // &&schooldId

            for (let l = 0; l < this.labels.length; l++) {
              if (this.labels[l].name.toLowerCase() === events[i].nom_type_evenement.toLowerCase() && this.labels[l].schoolId === schoolId) {
                event.labelId = this.labels[l].id
              }
              if ((events[i].nom_ecole === 'ISG B&M' && events[i].nom_type_evenement === 'Journée d’immersion' && this.labels[l].name === 'Journées Immersives')) {
                event.labelId = this.labels[l].id
              }
              if ((events[i].nom_ecole === 'EPITA' && events[i].nom_type_evenement === 'Journée d’immersion' && this.labels[l].schoolId === schoolId)) {
                event.labelId = this.labels[l].id
              }
              if ((events[i].nom_ecole === 'EPITA' && events[i].nom_type_evenement === 'Evénements' && this.labels[l].name === 'Evénement' && this.labels[l].schoolId === schoolId)) {
                event.labelId = this.labels[l].id
              }
            }

            if (event.labelId === undefined) {
              if (!this.unknown_label.includes(events[i].nom_type_evenement)) {
                this.unknown_label.push(events[i].nom_type_evenement)
              }
            }

            // Recherche de l'établissement

            for (let e = 0; e < this.establishments.length; e++) {
              if (this.establishments[e].school.name === events[i].nom_ecole && this.establishments[e].city.name === events[i].nom_ville) {
                event.establishmentId = this.establishments[e].id
              } else {
                if (this.establishments[e].school.name === 'Moda Domani Institute' && events[i].nom_ecole === 'Moda Domani' && this.establishments[e].city.name === events[i].nom_ville) {
                  event.establishmentId = this.establishments[e].id
                }
                if (this.establishments[e].school.name === 'Ionis-STM' && events[i].nom_ecole === 'IONIS-STM' && this.establishments[e].city.name === events[i].nom_ville) {
                  event.establishmentId = this.establishments[e].id
                }
                if (this.establishments[e].school.name === 'ISG MSc & MBA' && events[i].nom_ecole === 'ISG MSc' && this.establishments[e].city.name === events[i].nom_ville) {
                  event.establishmentId = this.establishments[e].id
                }
                if (this.establishments[e].school.name === 'ISEG' && events[i].nom_ecole === 'ISEG MCS' && this.establishments[e].city.name === events[i].nom_ville) {
                  event.establishmentId = this.establishments[e].id
                }
                if (this.establishments[e].school.name === 'SUP\'Internet' && events[i].nom_ecole === 'SupInternet' && this.establishments[e].city.name === events[i].nom_ville) {
                  event.establishmentId = this.establishments[e].id
                }
                if (this.establishments[e].school.name === 'Sup\'Biotech' && events[i].nom_ecole === 'SupBiotech' && this.establishments[e].city.name === events[i].nom_ville) {
                  event.establishmentId = this.establishments[e].id
                }
                if (this.establishments[e].school.name === 'ISG Business & Management' && events[i].nom_ecole === 'ISG B&M' && this.establishments[e].city.name === events[i].nom_ville) {
                  event.establishmentId = this.establishments[e].id
                }
                if (this.establishments[e].school.name === 'EPITA' && this.establishments[e].city.name === 'Paris' && events[i].nom_ville === 'Ingénieurs') {
                  event.establishmentId = this.establishments[e].id
                }
                if (this.establishments[e].school.name === 'ISG Bachelor Management International' && events[i].nom_ecole === 'ISG International' && this.establishments[e].city.name === events[i].nom_ville) {
                  event.establishmentId = this.establishments[e].id
                }
                if (this.establishments[e].school.name === 'ISG' && events[i].nom_ecole === 'ISG' && this.establishments[e].city.name === 'Paris' && events[i].nom_ville === 'Paris XVI') {
                  event.establishmentId = this.establishments[e].id
                }
              }
            }

            // On met à jour les adresses événement

            if (event.establishmentId !== undefined) {
              let establishment = this.establishments.find(a => a.id === event.establishmentId)
              if (establishment !== undefined) {
                event.address = establishment.address
                event.postal_code = establishment.zip_code
                event.city = establishment.city.name
                event.google_map = establishment.map
              }
            }

            if (event.establishmentId === undefined) {
              if (!this.unknown_establishments.includes(events[i].nom_ecole + ' ' + events[i].nom_ville)) {
                this.unknown_establishments.push(events[i].nom_ecole + ' ' + events[i].nom_ville)
              }
            }

            if (this.unknown_type.length > 0) {
              this.errorType = true
            }

            if (this.unknown_establishments.length > 0) {
              this.errorEstablishment = true
            }

            if (this.unknown_label.length > 0) {
              this.errorLabel = true
            }

            if (event.establishmentId !== undefined && event.typeId !== undefined) {
              // On vérifie si l'événement y est pas déjà
              // console.log('+++', event)
              let filter = {
                where: {
                  and: [
                    // { title: event.title },
                    { establishmentId: event.establishmentId },
                    { labelId: event.labelId },
                    { typeId: event.typeId },
                    { start_date: event.start_date },
                    // { end_date: event.end_date },
                    { start_time: event.start_time },
                    { end_time: event.end_time }
                  ]
                }
              }
              filter = encodeURIComponent(JSON.stringify(filter))
              this.$http.get(this.domain + '/api/events?filter=' + filter + '&access_token=' + this.access_token).then((response) => {
                response.json().then((data) => {
                  console.log('DATA LENGTH', data.length)
                  if (data.length === 0) {
                    console.log('====', event, data)
                    this.events_to_import.push(event)
                  }
                })
              }, (response) => {

              })
            }
          }
          if (this.unknown_establishments.length === 0 && this.unknown_type.length === 0 && this.unknown_label.length === 0) {
            // this.importTheData()
          }
        })
      }, (response) => {

      })
    }
  },
  mounted () {
    this.$http.get(this.domain + '/api/establishments?filter[include]=school&filter[include]=city&access_token=' + this.access_token).then((response) => {
      response.json().then((data) => {
        this.establishments = data
      })
    }, (response) => {

    })

    this.$http.get(this.domain + '/api/types?access_token=' + this.access_token).then((response) => {
      response.json().then((data) => {
        this.types = data
      })
    }, (response) => {

    })

    this.$http.get(this.domain + '/api/labels?access_token=' + this.access_token + '&filter[include]=school').then((response) => {
      response.json().then((data) => {
        this.labels = data
      })
    }, (response) => {

    })

    this.$http.get(this.domain + '/api/schools?access_token=' + this.access_token).then((response) => {
      response.json().then((data) => {
        this.schools = data
      })
    }, (response) => {

    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Import.vue